import { createSlice } from '@reduxjs/toolkit';
import { AppThunk } from '.';
import {showScroll} from '../app/utilities';
import { Video } from '../models/Video';

export interface VideoState {
    loading: boolean,
    recommendationsLoading: boolean;
    recommendationsLoaded: boolean;
    activeTab: string,
    video?: Video;
    recommendations: string | null;
}

let initialState: VideoState = {
    loading: false,
    recommendationsLoading: false,
    recommendationsLoaded: false,
    activeTab: '0',
    recommendations: null
}

export const videoSlice = createSlice({
    name: 'Video',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            showScroll(action.payload);
            state.loading = action.payload;
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
        setVideo: (state, action) => {
            state.video = action.payload;
        },
        setAiWidget: (state, action) => {
            if (state.video) {
                state.video.aiWidgetEnabled = action.payload;
            }
        },
        setRecommendations: (state, action) => {
            state.recommendations = action.payload;
        },
        setRecommendationsLoading: (state, action) => {
            state.recommendationsLoading = action.payload;
        },
        setRecommendationsLoaded: (state, action) => {
            state.recommendationsLoaded = action.payload;
        }
    }
});

export const { setLoading, setVideo, setAiWidget, setRecommendations, setRecommendationsLoaded, setRecommendationsLoading } = videoSlice.actions;

export const retrieveVideo = (videoId: string): AppThunk => async dispatch => {
    let url = 'api/video/retrieve';
    let sourceUrl = window.location.href;

    dispatch(setLoading(true));
    dispatch(setRecommendationsLoaded(false));
    dispatch(setVideo(undefined));
    dispatch(setRecommendations(null));
    fetch(url, {
        method: "POST",
        body: JSON.stringify({ id: videoId }),
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "same-origin"
    }).then(
        response => {
            if (response.status === 404) {
                dispatch(setLoading(false));
                return {
                    name: "NOT_AVAILABLE",
                    href: sourceUrl
                };
            }
            return response.json();
        }
    ).then(data => {
        dispatch(setVideo(data));
        dispatch(setLoading(false));
    }).catch(err => {
        console.error(err);
        dispatch(setLoading(false));
    });
}

export default videoSlice.reducer;
